import { Icon } from "./Icon";
import "./Checkbox.css";

type Props = {
  checked: boolean;
  onChange?: (next: boolean) => void;
  disabled?: boolean;
  label?: string;
  size?: number;
};

export function Checkbox({ checked, onChange, disabled, label, size = 14 }: Props) {
  const box = (
    <button
      type="button"
      className={`chk ${checked ? "on" : ""}`}
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) onChange?.(!checked);
      }}
      disabled={disabled}
      aria-pressed={checked}
    >
      {checked && <Icon name="check" size={size} stroke={3} />}
    </button>
  );
  if (!label) return box;
  return (
    <label className="ui-checkbox">
      {box}
      <span>{label}</span>
    </label>
  );
}
